import React from "react";
import { Card, Row, Col } from "react-bootstrap";

function KpisEstatisticas({ kpis }) {
  if (!Array.isArray(kpis) || kpis.length === 0) return null;
  return (
    <Row className="g-3 mb-4">
      {kpis.map(({ label, valor, cor }) => (
        <Col key={label}>
          <Card style={{ borderLeft: `4px solid ${cor}` }}>
            <Card.Body>
              <Card.Title className="small text-muted mb-1">{label}</Card.Title>
              <p className="mb-0 fs-5 fw-bold" style={{ color: cor }}>{valor}</p>
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default KpisEstatisticas;
